import { url as newsURL } from '../index';
import ApiService from '@api/api-service';

export const url = `${newsURL}`;
export default new ApiService(url);
